import React from 'react'

import { withUserStore } from '../../contexts/UserStore'
import { withModals } from '../../contexts/modals'
import ButtonsView from './ButtonsView'

// Full-width stacked list. reactstrap Container/Row/Col (every Col was xl12 =
// full width) become plain flow divs under `.cbs-scope`. Custom app classes
// (full-width, border05, …) are global and unchanged. (#635)
const ListView = ({ entries, modalActions, recordType, userStore }) => {
  const click = (e, entry) => {
    e.stopPropagation()
    if (entry.click) entry.click(entry.editModal.formRecord)
    if (entry.clickModal) modalActions.openModal(entry.clickModal)
    if (entry.clickUrl) userStore.appNavigate(entry.clickUrl)
  }

  return (
    <div className="cbs-scope full-width margin-top">
      {entries.map((entry, index) => (
        <div
          key={index}
          onClick={(e) => click(e, entry)}
          className="border05 margin2 rounded05 padding10 hover relative line-height-1"
        > {entry.el}
          <ButtonsView type={recordType} entry={entry} index={index} />
        </div>
      ))}
    </div>
  )
}

export default withUserStore(withModals(ListView))
